
	import Vue from "vue"
	import Component from "vue-class-component"
	import PCheckbox from "@portal-components/ui/input/PCheckbox.vue"

	import { Intermediary, Address, Agreement, AuthorizeModel, Company } from "store/company/types"
	import { StoreAction } from "@lib/types/vuex"
	import { Watch } from "vue-property-decorator"
	import { companyModule } from "store/modules"
	import localStorageClient from "api/clients/local-storage-client"

	@Component({
		components: {
			PCheckbox
		}
	})
	export default class MyAdvisor extends Vue {
		@companyModule.Getter company?: Company
		@companyModule.Getter intermediary?: Intermediary
		@companyModule.Getter agreement?: Agreement
		@companyModule.Getter canViewParticipants?: boolean
		@companyModule.Getter canAdministrationForEmployer?: boolean
		@companyModule.Action authorizeAdvisor!: StoreAction<AuthorizeModel>

		readonly baseTranslationKey = "profile.myAdvisor"
		checkImpersonate = localStorageClient.getItem("CHECK_IMPERSONATE")

		hasPermission = false
		hasAdministrationPermissionForEmployer = false

		isCheckImpersonate(value: any): boolean {
			if(value === "1") {
				return true
			} else {
				return false
			}
		}

		get address(): Address | undefined {
			return this.intermediary?.address?.business
		}

		@Watch("canViewParticipants", { immediate: true })
		permissionChanged(hasPermission: boolean): void {
			this.hasPermission = hasPermission
		}

		@Watch("canAdministrationForEmployer", { immediate: true })
		administrationForEmployer(hasPermission: boolean): void {
			this.hasAdministrationPermissionForEmployer = hasPermission
		}

		async authorize(): Promise<void> {
			if (!this.intermediary || !this.agreement || !this.company) {
				return
			}

			await this.authorizeAdvisor({
				companyId: this.company.externalIdentifier,
				intermediaryId: this.intermediary.externalIdentifier,
				agreementId: this.agreement.externalIdentifier,
				viewParticipants: this.hasPermission,
				administrationForEmployer: this.hasAdministrationPermissionForEmployer
			})
		}
	}
